import { Tag } from 'antd'
import type { KnowledgeScope } from '../../constants/knowledgeScope'
import { BrowseField } from './BrowseField'
import { TagsBrowsePanel } from './TagsBrowsePanel'

type Props = {
  value?: string[]
  onChange?: (tags: string[]) => void
  scope: KnowledgeScope
  placeholder?: string
  disabled?: boolean
  className?: string
  trigger?: 'hover' | 'click'
  block?: boolean
}

export function KnowledgeTagsBrowseField({
  value,
  onChange,
  scope,
  placeholder = '请选择标签',
  disabled,
  className,
  trigger = 'hover',
  block = false,
}: Props) {
  const tags = value || []

  return (
    <BrowseField
      placeholder={placeholder}
      hidePlaceholder
      disabled={disabled}
      className={className}
      trigger={trigger}
      block={block}
      panelClassName="app-browse-popover-panel--tags"
      panel={<TagsBrowsePanel scope={scope} value={tags} onChange={onChange} />}
    >
      {tags.length ? (
        <span className="app-browse-field-tags">
          {tags.map((tag) => (
            <Tag key={tag}>{tag}</Tag>
          ))}
        </span>
      ) : null}
    </BrowseField>
  )
}
